import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import ValueField from "../../components/forms/ValueField";
import FormError from "../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class SubscriptionQuantityForm extends Component {

  render() {
    let {errors, handleSubmit, productTitle, submit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <ValueField
              label="Product"
              value={productTitle}
              />
            <Field 
              label="Quantity"
              name="quantity"
              type="number"
              component={TextInputField}
              serverError={this.props.errors.quantity}
              normalize={numerical}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "SubscriptionQuantityForm"
})(SubscriptionQuantityForm);

export default ReduxForm;